export function farloUiGallery(element) {
    const gallerySlider = element.querySelector('.gallery__container');
    const galleryPagination = element.querySelector('.gallery__pagination');

    let flktyGallery;
    let flktyPagination;

    function initialiseFlickity() {
        // Initialize gallery slider Flickity only if not already initialised
        if (!flktyGallery) {
            flktyGallery = new Flickity(gallerySlider, {
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                groupCells: false,
                pageDots: false,
                prevNextButtons: false,
            });

            if (galleryPagination) {
                flktyPagination = new Flickity(galleryPagination, {
                    asNavFor: gallerySlider,
                    contain: true,
                    cellAlign: 'left',
                    pageDots: false,
                    prevNextButtons: false,
                    wrapAround: true,
                    groupCells: false,
                });
            }
        }
        // Ensure Flickity resizes after initialization
        setTimeout(() => {
            flktyGallery.resize();
            if (flktyPagination) flktyPagination.resize();
        }, 100);
    }
    initialiseFlickity();


    if (document.querySelector('.farlo-ui-lightbox__toggle')) {
        document.querySelectorAll('.farlo-ui-lightbox__toggle').forEach((_sel) => {
        _sel.addEventListener('click', () => {
            setTimeout(() => {
                initialiseFlickity();
            }, 100);
        });
        });
    }
}
